import dynamic from 'next/dynamic'

export const DynamicStoresCarouselDisclaimerDrawer = dynamic(
  () => import('.').then((mod) => mod.StoresCarouselDisclaimerDrawer),
  { ssr: false },
)
